(function ($) {
  $.fn.mySlidePlugin = function (interval, space) {
    var conteiner = this;

    var width_to_move = ($($(conteiner).children().first()[0]).width() + space) * interval;


    $(conteiner).parent().append('<div class="btnWrap">' +
      '<button class="rightBtn"></button>' +
      '<button class="leftBtn"></button>' +
      '</div>');

    $(conteiner).parent().find('.leftBtn').css('display', 'none');
    var pos = 0;

    window.addEventListener("resize", function() {
      pos=0;
      $(conteiner).css("margin-left", pos);
      width_to_move = ($($(conteiner).children().first()[0]).width() + space) * interval;
    }, false);
    $(conteiner).parent().find('.rightBtn').click(function () {
      $(conteiner).parent().find('.leftBtn').css("display", "block");
      if ($(conteiner).children().last().offset().left > $(conteiner).parent().offset().left + $($(conteiner).parent()).width()) {
        pos -= width_to_move;
        $(conteiner).css("margin-left", pos)
      }
      else {
        $(this).css("display", "none");
      }
    })
    $(conteiner).parent().find('.leftBtn').click(function () {
      $(conteiner).parent().find('.rightBtn').css("display", "block");
      if (($(conteiner).children().first().offset().left + space) < $(conteiner).parent().offset().left) {
        pos += width_to_move;
        $(conteiner).css("margin-left", pos)
      }
      else {
        $(this).css("display", "none");
      }
    })
  }
})(jQuery);
/*--------------------------------------------------------------------------*/




/*****************
 ** WEBPACK FOOTER
 ** ./gulp/assets/javascripts/slider_plugin.js
 ** module id = 12
 ** module chunks = 0
 **/